function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_257",
  "data-name": "Path 257",
  d: "M0,0H110V110H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_258",
  "data-name": "Path 258",
  d: "M75.333,88.083H11.167V23.917h41.25V14.75H11.167A9.194,9.194,0,0,0,2,23.917V88.083a9.194,9.194,0,0,0,9.167,9.167H75.333A9.194,9.194,0,0,0,84.5,88.083V46.833H75.333Zm-35.7-14.529L30.646,62.738l-12.6,16.179H68.458L52.233,57.329ZM84.5,14.75V1H75.333V14.75H61.583c.046.046,0,9.167,0,9.167h13.75v13.7c.046.046,9.167,0,9.167,0v-13.7H98.25V14.75Z",
  transform: "translate(7.167 3.583)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_259",
  "data-name": "Path 259",
  d: "M75.333,88.083H11.167V23.917h41.25V14.75H11.167A9.194,9.194,0,0,0,2,23.917V88.083a9.194,9.194,0,0,0,9.167,9.167H75.333A9.194,9.194,0,0,0,84.5,88.083V46.833H75.333Zm-35.7-14.529L30.646,62.738l-12.6,16.179H68.458L52.233,57.329ZM84.5,14.75V1H75.333V14.75H61.583c.046.046,0,9.167,0,9.167h13.75v13.7c.046.046,9.167,0,9.167,0v-13.7H98.25V14.75Z",
  transform: "translate(7.167 3.583)"
});

function SvgSelectPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_photo_alternate-24px_2_",
    "data-name": "add_photo_alternate-24px (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectPhoto);
export default __webpack_public_path__ + "static/media/select-photo.1542e6a3.svg";
export { ForwardRef as ReactComponent };